import { render, staticRenderFns } from "./member_ai_study.vue?vue&type=template&id=c116582c&scoped=true"
import script from "./member_ai_study.vue?vue&type=script&lang=js"
export * from "./member_ai_study.vue?vue&type=script&lang=js"
import style0 from "./member_ai_study.vue?vue&type=style&index=0&id=c116582c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c116582c",
  null
  
)

export default component.exports